const tab_sections = {
    identity: 'ID 및 조직',
    integrations: '앱 및 연결',
    login_security: '로그인 및 보안',
    permissions: '권한 및 리소스',
    automation: '자동화 및 감사',
    platform: '플랫폼',
    overview: '개요',
    authentication: '인증',
    authorization: '인가',
    users: '사용자',
    developer: '개발자',
    tenant: '임차인',
};
export default Object.freeze(tab_sections);
